<template>
  <div class="m-activity-list">
    <Search :renderData="renderData" :formData="form" @onSearch="onSearch" >
      <el-button slot="btn" @click="onExport" :loading="exportLoading">批量导出</el-button>
    </Search>
    <div class="fun-btn-box">
      <auth-button auth="market:activity:create">
        <el-button type="primary" class="mr10" @click="onAdd" >+ 创建活动</el-button>
      </auth-button>
    </div>
    <Table
      ref="table"
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :offset="offset"
      :total="total"
      :selection="true"
      @selectTable="selectTable"
      @selectTable_all="selectTable_all"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #id="{ row }">{{ row.id }}</template>
      <template #name="{ row }">{{ row.name }}</template>
      <template #time="{ row }">
        {{ row.startTime ? $moment(row.startTime).format('YYYY/MM/DD HH:mm:ss') : '' }}
        <span> - </span>
        {{ row.endTime ? $moment(row.endTime).format('YYYY/MM/DD HH:mm:ss') : '' }}
      </template>
      <template #status="{ row }">{{ row.status }}</template>
      <template #useRange="{ row }">{{ useRangeObjData[row.useRange] ? useRangeObjData[row.useRange] : '---' }}</template>
      <template #scene="{ row }">{{ scencObjData[row.scene] ? scencObjData[row.scene] : '---' }}</template>
      <template #deliveryChannel="{ row }">{{ deliveryChannelObjData[row.deliveryChannel] || '---' }}</template>
      <template #type="{ row }">{{ typeObjData[row.type] ? typeObjData[row.type] : '---' }}</template>
      <template #scopeType="{ row }">
        {{ row.mallIds.length ? '指定商场' : '所有商场' }}
      </template>
      <template #operatorName="{ row }">{{ row.operatorName }}</template>
      <template #operation="{ scope }">
        <el-row>
          <el-button type="text" @click="onDetail(scope.row)" class="mr10">查看详情</el-button>
          <auth-button auth="market:activity:switch">
            <el-button v-if="scope.row.status != '已结束' && scope.row.disable" type="text" @click="onEditStatus(scope.row, false)" class="mr10">启用</el-button>
            <el-button v-else-if="scope.row.status != '已结束'" type="text" @click="onEditStatus(scope.row, true)" class="mr10 error">停止</el-button>
          </auth-button>
          <auth-button auth="market:activity:create">
            <el-button v-if="scope.row.type == 'CouponCenter' || scope.row.type == 'SaleCoupon'" type="text" class="edit" @click="onCopy(scope.row)">复制</el-button>
          </auth-button>
        </el-row>
        <el-row>
          <el-button v-if="scope.row.hidden" type="text" @click="onDownloadCode(scope.row, 'coupon')" class="mr10">下载券二维码</el-button>
        </el-row>
        <el-row>
          <el-button v-if="(scope.row.type == 'Roulette' || scope.row.type == 'Lottery') && (scope.row.scene == 'LotteryCenter' || scope.row.scene == 'CouponDeal') && (scope.row.status !== '已结束')" type="text" @click="onDownloadCode(scope.row, 'activity')" class="mr10">下载活动二维码</el-button>
        </el-row>
      </template>
    </Table>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import { api_getActivityList, api_putUpdateActivityStatus, api_getHideActiveCouponCode, api_getActiveCode,api_getActivityRecordExportAll } from '@/api/market'
import tableList from '@/mixins/tableList';
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import { downFile } from "@/utils";
export default {
  name: "marketActivityListIndex",
  mixins: [tableList],
  components: {
    AuthButton,
    Search,
    Table,
  },
  data() {
    return {
      renderData: [
        {
          label: "活动名称",
          placeholder: "请输入活动名称",
          type: "input",
          key: "name",
        },
        {
          label: "活动状态",
          placeholder: "请选择活动状态",
          type: "select",
          key: "status",
          option: [
            { label: "未开始", value: 'New', },
            { label: "进行中", value: 'Doing', },
            { label: "已停止", value: 'Stopped', },
            { label: "已结束", value: 'Ended', },
          ],
        },
        {
          label: "活动类型",
          placeholder: "请选择活动类型",
          type: "select",
          key: "type",
          option: [
            { label: "大转盘", value: 'Roulette', },
            { label: "刮刮乐", value: 'Lottery', },
            { label: "领券中心", value: 'CouponCenter', },
            { label: "售券", value: 'SaleCoupon', },
            { label: "活动报名", value: 'SignUp', },
            { label: "秒杀", value: 'FlashSaleCoupon', },
            { label: "发券活动", value: 'CouponDistribution', },
          ],
        },
        {
          label: "触发场景",
          placeholder: "请选择触发场景",
          type: "select",
          key: "scene",
          option: [
            { label: "支付成功页面", value: 'AfterPay', },
            { label: "注册", value: 'Register', },
            { label: "抽奖中心", value: 'LotteryCenter', },
            { label: "券核销", value: 'CouponDeal', },
            { label: "商品支付成功页", value: 'SupplierAfterPay', },
          ],
        },
        {
          label: "参与限制",
          placeholder: "请选择参与限制",
          type: "select",
          key: "useRange",
          option: [
            { label: "全场通用", value: 'Generic', },
            { label: "指定商场", value: 'Mall', },
            { label: "指定店铺", value: 'Store', },
          ],
        },
        {
          label: "投放渠道",
          placeholder: "请选择参与限制",
          type: "select",
          key: "deliveryChannel",
          option: [
            { label: "首页", value: 'First', },
            { label: "权益聚合页", value: 'WelfareCoupon', },
          ],
        },
      ],
      form: {},
      tableThData: [
        { prop: "id", label: "活动ID", minWidth: "80", },
        { prop: "name", label: "活动名称", minWidth: "150", },
        { prop: "time", label: "活动时间", minWidth: "200", },
        { prop: "status", label: "活动状态", minWidth: "120", },
        { prop: "scene", label: "触发场景", minWidth: "120", },
        { prop: "useRange", label: "参与限制", minWidth: "120", },
        { prop: "deliveryChannel", label: "投放渠道", minWidth: "120", },
        { prop: "type", label: "活动类型", minWidth: "100", },
        { prop: "scopeType", label: "范围类型", minWidth: "100", },
        { prop: "operatorName", label: "操作人", minWidth: "100", },
        { prop: "operation", label: "操作", minWidth: "180", },
      ],

      scencObjData: {
        'AfterPay': '支付成功页面',
        'LotteryCenter': '抽奖中心',
        'Register': '注册',
        'CouponDeal': '券核销',
        'SupplierAfterPay': '商品支付成功页',
      },
      typeObjData: {
        'Roulette': '大转盘',
        'Lottery': '刮刮乐',
        'CouponCenter': '领券中心',
        'SaleCoupon': '售券',
        'SignUp': '活动报名',
        'FlashSaleCoupon': '秒杀',
        'CouponDistribution': '发券活动',
      },
      useRangeObjData: {
        'Generic': '全场通用',
        'Mall': '指定商场',
        'Store': '指定店铺',
      }, // 参与限制枚举
      deliveryChannelObjData: {
        'First': '首页',
        'WelfareCoupon': '权益聚合页',
      }, // 投放渠道枚举
      detailPage: {
        CouponDistribution: '/market/activityList/addSendCoupon',
        FlashSaleCoupon: '/market/activityList/addSeckill',
        CouponCenter: '/market/activityList/addCouponCenter',
        SaleCoupon: '/market/activityList/addCouponSell',
        SignUp: '/market/activityList/addActivityApply',
        Roulette: '/market/activityList/add',
        Lottery: '/market/activityList/add'
      },
      exportLoading:false,
      selectedIds:[],
      selectedData:[],
    };
  },
  created() {},
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      try {
        const data = await api_getActivityList(params)
        console.log('data: ', data);
        this.tableTrData = data.list
        this.total = data.count
        this.loading = false
      } catch {
        this.loading = false
      }
      this.handleEchoSelect() // 回显选中项
    },

    // 点击创建按钮
    onAdd() {
      this.$router.push("/market/activityList/select");
    },

    // 点击查看详情
    onDetail(row) {
      if (this.detailPage[row.type]) {
        this.$router.push(`${this.detailPage[row.type]}?id=${row.id}&type=${row.type}&page=detail`);
      } else {
        this.$baseMessage('该活动暂无活动类型', 'warning')
      }
    },

    // 复制
    onCopy(row) {
      this.$router.push(`${this.detailPage[row.type]}?id=${row.id}&type=${row.type}&page=copy`);
    },

    // 点击修改状态
    onEditStatus(row, value) {
      this.$baseConfirm(
        `是否要${value ? '停止' : '启用'}该活动？`,
        { title: '提示', type: 'warning', },
        async () => {
          await api_putUpdateActivityStatus({id: row.id, disable: value})
          this.$baseMessage('操作成功', 'success')
          this.getList()
        }
      )
    },
    // 下载二维码
    async onDownloadCode(row, type) {
      let loading = this.$baseLoading(6)
      try {
        let res = null
        if (type == 'coupon') {
          res = await api_getHideActiveCouponCode({id: row.id})
        } else {
          res = await api_getActiveCode({ id: row.id })
        }
        console.log('res: ', res);
        const url = window.URL.createObjectURL(new Blob([res.data]))
        let fileName = res.headers['content-disposition'] ? res.headers['content-disposition'].split('filename=')[1] : ''
        console.log('fileName: ', fileName);
        fileName = decodeURI(fileName)
        const link = document.createElement('a')
        link.target = '_blank'
        link.href = url
        link.setAttribute('download', fileName)
        link.click()
      } catch (err) {
        this.$baseMessage('下载失败', 'error')
        console.log('err: ', err);
      }
      loading.close()
    },

    // 禁用选项
    checkSelectable_all(row) {
      return row.type == 'CouponCenter' || (row.type == 'SaleCoupon' && row.deliveryChannel !== 'WelfareCoupon') ? true : false
    },
      // 回显选中项
    handleEchoSelect() {
      let selectRow = this.tableTrData.filter(item => this.selectedIds.indexOf(item.id) >= 0)
      setTimeout(() => {
        selectRow.forEach(item => {
          this.$refs.table.$refs.myTable.toggleRowSelection(item, true);
        })
      }, 100)
    },
      // 表格单选选择
      selectTable(selection, row) {
        let curRowIndex = selection.findIndex(item => item.id == row.id)
        if (curRowIndex >= 0) {
          // 选择
          this.selectedData.push(row)
        } else {
          // 取消选择
          this.selectedData = this.selectedData.filter(item => item.id !== row.id)
        }
        this.selectedIds = this.selectedData.map(item => item.id)
      },

      // 表格全选选择
      selectTable_all(selection) {
        if (selection.length) {
          // 全选
          let curRow = this.tableTrData.filter(item => this.selectedIds.indexOf(item.id) < 0)
          this.selectedData = [...this.selectedData, ...curRow]
        } else {
          // 取消全选
          let curTableIds = this.tableTrData.map(item => item.id)
          this.selectedData = this.selectedData.filter(item => curTableIds.indexOf(item.id) < 0)
        }
        this.selectedIds = this.selectedData.map(item => {
          if(item.type == 'CouponCenter' || item.type == 'SaleCoupon' ){
            return item.id
          }else{
            return ''
          }
        })
      },
      // 导出
    async onExport() {
      if (this.selectedIds.length==0){
        this.$baseMessage('请选择需要导出的数据', 'error')
        return
      }
      this.exportLoading = true
      let newarr = this.selectedIds.filter(item=>!["",null,undefined,NaN,false,true].includes(item));
      const params = {
        activityIds:newarr.join(',')
      }
      let res = await api_getActivityRecordExportAll(params)
      downFile(res)
      this.exportLoading = false
    },

  },
};
</script>

<style lang="scss" scoped>
.m-activity-list {
  padding: 0 20px;
  box-sizing: border-box;

  .fun-btn-box {
    margin-top: 20px;
  }
}
</style>
